import useIsMobile from '@/helpers/commonHooks/useIsMobile';
import { observer } from 'mobx-react';
import MemberRequestPagePc from './components/MemberRequestPagePc/MemberRequestPagePc';
import MemberRequestPageMobile from './components/MemberRequestPageMobile/MemberRequestPageMobile';

function MemberRequestPage() {
  const isMobile = useIsMobile()
  return isMobile ? <MemberRequestPageMobile /> : <MemberRequestPagePc />
}

export default observer(MemberRequestPage)
